/**
 * Roadmap Card Component (Enhanced)
 * 
 * Card with:
 * - Direct upvote button (clickable for all, triggers auth for guests)
 * - Category badge
 * - Comments count
 * - Click to open detail modal
 */

import { __ } from '@wordpress/i18n';

// Helper to strip HTML tags for plain text preview
const stripHtml = (html) => {
    if (!html) return '';
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
};

const RoadmapCard = ({ item, onCardClick, onUpvote, isLoggedIn, showVoteCount = true, onAuthRequired }) => {
    const categoryLabels = {
        'feature_requests': __( 'Feature Request', 'changeloger-pro' ),
        'bug_reports': __( 'Bug Report', 'changeloger-pro' ),
        'integrations': __( 'Integration', 'changeloger-pro' ),
        'languages': __( 'Language', 'changeloger-pro' )
    };

    const category = item.category?.slug || item.category || 'feature_requests';

    const handleCardClick = (e) => {
        // Don't trigger if clicking upvote button
        if (e.target.closest('.cha-roadmap-upvote')) return;
        if (onCardClick) onCardClick(item);
    };

    const handleUpvote = (e) => {
        e.stopPropagation();
        // If not logged in, trigger auth modal
        if (!isLoggedIn && onAuthRequired) {
            onAuthRequired();
            return;
        }
        if (onUpvote) onUpvote(item.id);
    };


    return (
        <div 
            className={`cha-roadmap-card ${item.type === 'manual' ? 'manual' : ''}`}
            onClick={handleCardClick}
        >
            {/* Title */}
            <h4 className="cha-roadmap-card-title">{item.title}</h4>
            
            {/* Footer with category, comments, votes */}
            <div className="cha-roadmap-card-footer">
                {/* Category Badge */}
                <span className="cha-roadmap-card-category">
                    <span className="cha-category-icon">💡</span>
                    {categoryLabels[category] || (item.type === 'manual' ? __( 'Roadmap', 'changeloger-pro' ) : __( 'Feedback', 'changeloger-pro' ))}
                </span>
                
                {/* Comments Count */}
                {(item.comment_count > 0 || item.comments > 0) && (
                    <span className="cha-roadmap-card-comments">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="14" height="14">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                        </svg>
                        {item.comment_count || item.comments || 0}
                    </span>
                )}
                
                {/* Upvote Button - Only show if showVoteCount is true */}
                {showVoteCount !== false && (
                <button 
                    className={`cha-roadmap-upvote ${item.has_voted ? 'voted' : ''}`}
                    onClick={handleUpvote}
                    title={__( 'Upvote', 'changeloger-pro' )}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="14" height="14">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                    </svg>
                    <span>{item.votes || 0}</span>
                </button>
                )}
            </div>
        </div>
    );
};

export default RoadmapCard;
